module.exports = __webpack_public_path__ + "fonts/SF-Pro-Display-Bold.644563f4.otf";